import { SwitchrProvider, type SwitchrUser } from '@shutterstock-private/switchr-react';

export { useSwitchr } from '@shutterstock-private/switchr-react';

export type ContributorWebSwitchrProviderProps = React.PropsWithChildren<{
  switchrProps: {
    user: SwitchrUser;
    data: string;
    key: string;
  };
}>;

export const ContributorWebSwitchrProvider = ({ switchrProps, children }: ContributorWebSwitchrProviderProps) => (
  <SwitchrProvider
    config={{
      key: switchrProps?.key,
      options: {
        disableLogging: !!switchrProps?.user?.custom?.isBot,
        networkConfig: {
          // This comes from the statsig proxy url found in project settings keys setting
          api: 'https://wos7oui7lzrtk25y2ylbmzyasa0rqmwe.lambda-url.ap-south-1.on.aws/v1',
        },
      },
    }}
    serverData={switchrProps?.data}
    user={switchrProps?.user}
  >
    {children}
  </SwitchrProvider>
);
